import { render, staticRenderFns } from "./FilterHeader.vue?vue&type=template&id=4891c5d2&"
import script from "./FilterHeader.vue?vue&type=script&lang=js&"
export * from "./FilterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports